module.exports = "https://r.zoocdn.com/_next/static/images/hero-640-10f4f7599b3a15109e7f1e0ac4bba1a4.jpg";